import NonFeasibleEstimationMessage from './NonFeasibleEstimationMessage.styled';

export default NonFeasibleEstimationMessage;
